import React from 'react';
import { useQuery } from 'react-apollo';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useHomeMarket from 'hooks/useHomeMarket';

import { Title } from 'screens/styled_common';
import { CareTeamResponse, CARE_TEAM_QUERY } from './graphql/queries';
import { PersonWrapper, Container, DescriptionText, CareTeamPeople, Title2 } from './styled';

const CareTeam = () => {
  const { t: translate } = useTranslation();
  const { name: homeMarketName } = useHomeMarket();
  const { data } = useQuery<CareTeamResponse>(CARE_TEAM_QUERY);

  return (
    <Container>
      <div className="header-wrapper">
        <Title>{translate('care_team.page.title')}</Title>

        <DescriptionText>{translate('care_team.page.description')}</DescriptionText>

        {homeMarketName && (
          <Title2>{translate('care_team.your_home_market', { name: homeMarketName })}</Title2>
        )}

        <Link data-testid="change-home-market-link" to="/messages">
          {translate('care_team.change_home_market_link_text')}
        </Link>

        {data && (
          <CareTeamPeople>
            {data.careTeam?.doctor && (
              <Person responsability="PROVIDER OF RECORD" name={data.careTeam.doctor} />
            )}
            {data.careTeam?.clinicNurse && (
              <Person responsability="CLINIC NURSE" name={data.careTeam.clinicNurse} />
            )}
            {data.careTeam?.cloudNurse && (
              <Person responsability="CLOUD NURSE" name={data.careTeam.cloudNurse} />
            )}
          </CareTeamPeople>
        )}
      </div>
    </Container>
  );
};

export default CareTeam;

const Person = ({ name, responsability }: { name: string; responsability: string }) => (
  <PersonWrapper data-testid="person-wrapper">
    <span className="responsability">{responsability}</span>
    <h3 className="name">{name}</h3>
  </PersonWrapper>
);
